import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { PublicReportsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

export type PublicReport = NonNullable<PublicReportsQuery["publicReports"]>["reports"][number];

const PUBLIC_REPORTS_QUERY = graphql(`
  query publicReports {
    publicReports {
      reports {
        id
        title
        description
        adminNotes
        publishedAt
        pdfUrl
        coverImageUrl
      }
    }
  }
`);

export function usePublicReports(
  options?: UseQueryOptions<PublicReportsQuery, unknown, PublicReportsQuery, QueryKey>,
) {
  const result = useGraphQlQuery(["reports", "public"], PUBLIC_REPORTS_QUERY, [{}], options);

  return { ...result, data: result.data?.publicReports?.reports };
}
